import { Card, CardContent, EmptyState, Flex, Heading, Paragraph, Icons } from "@ir/ui";

const WorkSpaceError: React.FC = () => {
  return (
    <Flex className="bg-white flex-1" justifyContent="center" align="center">
      <Card className="p-4 m-4">
        <CardContent>
          <EmptyState
            icon={Icons.AlertCircle}
            title={
              <Heading level={3} className="text-center text-grey-400 mt-3 font-bold">
                Something went wrong
              </Heading>
            }
            description={<Paragraph>Please contact support</Paragraph>}
          />
        </CardContent>
      </Card>
    </Flex>
  );
};
export default WorkSpaceError;
